import { defineStore } from 'pinia'
import { fetchSettings } from '~/services/settings'
import { TGlobalSettings, TNavigationSettings, TSeoSettings, TSettings } from '~/types/singleton-types'

type TStoreState = TSettings;

export const useSettingsStore = defineStore('settings', {
  state: (): TStoreState => {
    return {
      seo: undefined,
      global: undefined,
      navigation: undefined
      // project: undefined
    }
  },
  actions: {
    async loadSettings () {
      this.$state = await fetchSettings()
    }
  },
  getters: {
    getSeo: state => state.seo as TSeoSettings,
    getGlobal: state => state.global as TGlobalSettings,
    getNavigation: state => state.navigation as TNavigationSettings
    // getProject: state => state.project
  }
})
